module.exports = __webpack_public_path__ + "media/smart_sales/step-1-6e91234a.webp";